import * as React from 'react';
import {FunctionComponent} from 'react';
import {useParams} from 'react-router-dom';
import {WorkoutShare} from './WorkoutShare';

interface OwnProps {}

const GLOBAL = (window as any).DATA;

export const WorkoutShareContainer: FunctionComponent<OwnProps> = ({}) => {
    const {id, hash} = useParams<{hash: string; id: string}>();

    return <WorkoutShare id={parseInt(id!, 10)} hash={hash!} previewWorkout={GLOBAL?.preview} />;
};
